<template>
    <component @click="copyShareLink(shareType, title, url)" :is="tag">
        <slot />
    </component>
</template>

<script>
export default {
    props: {
        tag: {
            default: 'a'
        },

        shareType: {
            type: String,
            default: 'share'
        },

        url: {
            type: String,
            default: ''
        },

        title: {
            type: String,
            default: ''
        }
    },

    methods: {
        supportNavigatorShare() {
            return window.navigator.share != undefined
        },

        copyShareLink(type, title, url) {
            const successMessage = this.$t('playalone_summary_share_alert_link_copied')
            const errorMessage = this.$t('playalone_summary_share_alert_link_copied_error')

            const copyToClipboard = () => {
                navigator.clipboard
                    .writeText(url)
                    .then(() => {
                        this.toastSuccess(successMessage)
                    })
                    .catch(() => {
                        this.toastError(errorMessage)
                    })
            }

            const shareNavigator = () => {
                navigator
                    .share({
                        title: title,
                        text: `Join ${title} - TheBigQuiz`,
                        url: url
                    })
                    .then(() => {})
            }

            if (this.supportNavigatorShare()) {
                if (type === 'copy') {
                    copyToClipboard()
                }
                if (type === 'share') {
                    shareNavigator()
                }
            } else {
                copyToClipboard()
            }
        }
    }
}
</script>

